'use client';

import { LEGAL_ADMIN_PAGE } from '@/features/admin/constants/legal-admin-ui-copy';
import { LegalDocumentAdminPage } from '@/features/admin/presentation/sections/LegalDocumentAdminPage';

export interface PoliticaPrivacidadeAdminPageProps {
  editorDisplayName: string;
}

export default function PoliticaPrivacidadeAdminPage({ editorDisplayName }: PoliticaPrivacidadeAdminPageProps) {
  return (
    <LegalDocumentAdminPage
      kind="privacy"
      title={LEGAL_ADMIN_PAGE.PRIVACY_TITLE}
      subtitle={LEGAL_ADMIN_PAGE.PRIVACY_SUBTITLE}
      editorDisplayName={editorDisplayName}
    />
  );
}
